import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import PassageLayout from '../../../common/layouts/passageLayout';
import { SPINNER } from '../../../constants/components';
import LoadingPage from '../../../common/components/LoadingPage';
import GoButton from '../../../common/components/GoButton';
import { LC } from '../../../constants/measure';
import LCOneAnswerQuestionView from '../../../common/splitPageQuestion/LCOneAnswerQuestion/LCOneAnswerQuestionView';
import AudioContainer from '../../../common/audio/audioContainer';
import ScreenErrorContainer from '../../../common/error/ScreenErrorContainer';
import IllustrationContainer from '../../../common/illustration/IllustrationContainer';

const FIRST_QUESTION_INDEX = 0;

/* eslint-disable react/no-multi-comp */
const LCQuestionsView = props => {
    const {
        showSpinner,
        fetchContent,
        isDataFetched,
        hideSpinner,
        isSpinnerVisible,
        isScreenBlocked,
        isGreyedOut,
        currentContent,
        onNext,
        comprehensionItem,
        playQuestionAndResponseAudio,
        questionIndex,
        totalQuestions,
        cleanup
    } = props;
    const { possibleResponses, stimulus } = comprehensionItem;

    useEffect(() => {
        if (isDataFetched) {
            hideSpinner();
            if (questionIndex === FIRST_QUESTION_INDEX) playQuestionAndResponseAudio(stimulus.audio, possibleResponses);
        } else {
            showSpinner();
            fetchContent();
        }
    }, [isDataFetched]);

    useEffect(() => {
        if (isDataFetched && questionIndex < totalQuestions) playQuestionAndResponseAudio(stimulus.audio, possibleResponses);
    }, [questionIndex]);

    useEffect(() => cleanup, []);

    const getNextButtonText = () => questionIndex + 1 === totalQuestions ? 'Done' : 'OK';

    const getBottomNavigation = () => {
        const updatedIndex = props.questionIndex + 1;
        return (
            <div className="comprehension-bottom">
                <div className="comprehension-progress">
                    {updatedIndex}
                    {' '}
of
                    {' '}
                    {props.totalQuestions}
                </div>
            </div>
        );
    };

    const getQuestions = () => {
        const { isNextButtonActive, selectedIndex, selectAnswer, narrateStimulus } = props;
        return (
            <div className="question-pane">
                <LCOneAnswerQuestionView
                    measure={LC.ASSESSMENT}
                    possibleResponses={possibleResponses}
                    stimulus={stimulus}
                    selectedIndex={selectedIndex}
                    onAnswerClick={selectAnswer}
                    onNarrateStimulus={narrateStimulus}
                    isDisabled={isScreenBlocked}
                />
                {getBottomNavigation()}
                <div>
                    { isNextButtonActive
                        && (
                            <GoButton
                                className="go-button"
                                text={getNextButtonText()}
                                onClick={onNext}
                                isEnabled={!isScreenBlocked} />
                        )}
                </div>
            </div>
        );
    };

    return (
        <div>
            <PassageLayout
                class="lc-measure"
                isScreenBlocked={isScreenBlocked}
                isGreyedOut={isGreyedOut}
            >
                <div className="image-container">
                    { isDataFetched && (
                        <IllustrationContainer
                            url={currentContent.image}
                            class="lc-stimulus-illustration"
                            imageClass="lc-content-image"
                            altText=" " />
                    )}
                </div>
                <ScreenErrorContainer onRetry={onNext} />
                <AudioContainer />
                {isDataFetched && getQuestions()}
            </PassageLayout>
            {isSpinnerVisible && <LoadingPage spinnerConfig={SPINNER.DARK} />}
        </div>
    );
};

/* eslint-disable react/no-unused-prop-types */
LCQuestionsView.propTypes = {
    showSpinner: PropTypes.func,
    fetchContent: PropTypes.func,
    hideSpinner: PropTypes.func,
    onNext: PropTypes.func,
    isDataFetched: PropTypes.bool,
    isSpinnerVisible: PropTypes.bool,
    isScreenBlocked: PropTypes.bool,
    isGreyedOut: PropTypes.bool,
    currentContent: PropTypes.object,
    questionIndex: PropTypes.number,
    totalQuestions: PropTypes.number,
    isNextButtonActive: PropTypes.bool,
    comprehensionItem: PropTypes.object,
    selectedIndex: PropTypes.number,
    selectAnswer: PropTypes.func,
    narrateStimulus: PropTypes.func,
    playQuestionAndResponseAudio: PropTypes.func,
    cleanup: PropTypes.func
};

LCQuestionsView.defaultProps = {
    showSpinner: () => {},
    fetchContent: () => {},
    hideSpinner: () => {},
    onNext: () => {},
    questionIndex: 0,
    totalQuestions: 0,
    isDataFetched: false,
    isSpinnerVisible: false,
    isScreenBlocked: false,
    isGreyedOut: false,
    isNextButtonActive: false,
    currentContent: {
        image: ''
    },
    comprehensionItem: {
        possibleResponses: [],
        stimulus: {}
    },
    selectedIndex: undefined,
    selectAnswer: () => {},
    narrateStimulus: () => {},
    playQuestionAndResponseAudio: () => {},
    cleanup: () => {},
};

export default LCQuestionsView;
